// K177 2.1/2.4 + K178 F1–F8 (21 Sep 2026) — cermin murni pagar backend
// `services/konfigurasi_fa.py` untuk FA wizard. Nol panggilan API di sini;
// yang menjaga tetap router (K178 pagar), berkas ini hanya menyusun badan
// permintaan dan menerjemahkan bentuk lama ↔ K177 selama transisi.

export const ITEM_TYPE_TIGA = ["JERSEY_SAJA", "SET_CELANA_POLOS", "SET_CELANA_FULLPRINT"];
// U22b (22 Sep 2026): matriks kombinasi (kategori × item_type) adalah DATA
// (`kategori_harga.item_type_sah`) dan SUDAH disaring backend di
// `GET /fa-orders/pilihan-harga/wilayah/{region}` (`pricing.pilihan_item_type`) —
// cermin konstanta `MATRIKS_SAH` di sini DICABUT supaya tidak ada dua sumber yang
// bisa berselisih saat Owner mengubah matriks dari layar.
export const LABEL_ITEM_TYPE = {
  JERSEY_SAJA: "Jersey saja",
  SET_CELANA_POLOS: "Jersey set celana hitam/putih",
  SET_CELANA_FULLPRINT: "Jersey set celana full print",
};
// Label paket waktu pengerjaan untuk layar (K200 butir 6 — kode mentah tidak tampil ke staf).
export const LABEL_PAKET = { REGULER: "Reguler", EXPRESS: "Express", SUPER_EXPRESS: "Super Express" };
export const labelPaket = (kode) => (kode ? LABEL_PAKET[kode] || kode : "—");
export const LABEL_PRODUK = { ATASAN_ONLY: "Atasan Saja", SET_ATASAN_CELANA: "Set Atasan + Celana" };
export const labelProduk = (kode) => (kode ? LABEL_PRODUK[kode] || kode : "—");
export const POLA_BAJU = ["REGULER", "RAGLAN"];
export const WARNA_CELANA = ["HITAM", "PUTIH"];
export const JENIS_LENGAN = ["PENDEK", "PANJANG"];

/** Mode daftar harga wilayah untuk satu paket: "K177" bila baris bernama tiga
 *  item_type (kunci `jersey`/`set` dari GET pilihan-harga), "LAMA" bila hanya
 *  atasan/celana (24 baris 11–13 Sep), null bila paket nol punya harga. */
export function modeHargaPaket(pilihan, paket) {
  const p = pilihan?.[paket];
  if (!p) return null;
  const tiga = [...(p.jersey || []), ...(p.set || [])];
  if (tiga.length) return "K177";
  if ((p.atasan || []).length) return "LAMA";
  return null;
}

/** item_type K177 yang punya harga di paket ini (sudah disaring matriks oleh
 *  backend), urut tetap K177 2.1. */
export function itemTypeTersedia(pilihan, paket) {
  const p = pilihan?.[paket];
  const ada = new Set([...(p?.jersey || []), ...(p?.set || [])]);
  return ITEM_TYPE_TIGA.filter((t) => ada.has(t));
}

export function memakaiCelana(item) {
  if (item?.item_type) return item.item_type !== "JERSEY_SAJA";
  return item?.product_type === "SET_ATASAN_CELANA";
}

/** F4: ada baris SET_CELANA_POLOS → warna celana kepala wajib. */
export function butuhWarnaCelana(items) {
  return (items || []).some((i) => i.item_type === "SET_CELANA_POLOS");
}

/** Badan `POST /fa-orders/{id}/items` — kepala FA (paket · collar) dituruni
 *  ke tiap baris (F1); bentuk K177 bila `item_type` terisi, bentuk lama bila tidak. */
export function badanItems(items, kepala) {
  return (items || []).map((i) => {
    const dasar = {
      qty_atasan: Number(i.qty_atasan),
      size_code: i.size_code || null,
      collar_id: kepala?.collar_id || null,
      package_category: kepala?.package_category,
      description: i.description || null,
      design_ref: i.design_ref || null,
    };
    if (i.item_type) {
      return { ...dasar, item_type: i.item_type };
    }
    return {
      ...dasar,
      product_type: i.product_type,
      item_type_atasan: i.item_type_atasan,
      fabric_atasan: i.fabric_atasan || null,
      item_type_celana: i.product_type === "SET_ATASAN_CELANA" ? (i.item_type_celana || null) : null,
      fabric_celana: i.product_type === "SET_ATASAN_CELANA" ? (i.fabric_celana || null) : null,
    };
  });
}

/** Badan `PATCH /fa-orders/{id}/konfigurasi` — hanya ruas yang terisi. */
export function badanKonfigurasi(kepala) {
  const b = {};
  if (kepala?.pola_baju) b.pola_baju = kepala.pola_baju;
  if (kepala?.warna_celana) b.warna_celana = kepala.warna_celana;
  return b;
}

/** Badan roster (F6/F7/F8): `baris_item` (indeks baris pesanan di wizard) →
 *  `fa_item_id` sesudah items tersimpan; ukuran celana ikut hanya bila baris
 *  pesanannya memakai celana. Collar TIDAK dikirim — diisi sistem (F5). */
export function badanRoster(roster, itemIds, items) {
  return (roster || []).map((r, idx) => {
    const bi = r.baris_item == null || r.baris_item === "" ? null : Number(r.baris_item);
    const item = bi != null ? items?.[bi] : (items?.length === 1 ? items[0] : null);
    const faItemId = bi != null ? (itemIds?.[bi] || null) : (items?.length === 1 ? (itemIds?.[0] || null) : null);
    const pakaiCelana = memakaiCelana(item);
    return {
      row_no: idx + 1,
      nameset_punggung: r.nameset_punggung || null,
      nomor_punggung: r.nomor_punggung || null,
      ukuran_dewasa: r.ukuran_dewasa || null,
      ukuran_anak: r.ukuran_anak || null,
      gender: r.gender || null,
      jenis_lengan: r.jenis_lengan || null,
      fa_item_id: faItemId,
      ukuran_celana: pakaiCelana ? (r.ukuran_celana || null) : null,
    };
  });
}

/** Alasan baris roster nol bisa disimpan — cermin F6/F7 supaya CS tahu
 *  SEBELUM 400: baris pesanan wajib bila >1 item; ukuran celana wajib bila
 *  barisnya memakai celana. */
export function alasanRosterTerhalang(roster, items) {
  for (let idx = 0; idx < (roster || []).length; idx++) {
    const r = roster[idx];
    const bi = r.baris_item == null || r.baris_item === "" ? null : Number(r.baris_item);
    if ((items || []).length > 1 && bi == null) return `Roster baris ${idx + 1}: pilih baris pesanan (jersey saja / set celana).`;
    const item = bi != null ? items[bi] : items?.[0];
    if (memakaiCelana(item) && !(r.ukuran_celana || "").trim()) return `Roster baris ${idx + 1}: ukuran celana wajib (baris pesanannya memakai celana).`;
  }
  return null;
}

/** K106 / K118 — tangga ukuran (sama dengan `roster_validasi`); `2XL` bukan `XXL`, supaya tambahan ukuran
 *  (`size_surcharge_rules`: XL, 2XL, 3XL, ...) benar-benar terbaca (T21). */
export const UKURAN_DEWASA = ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL", "7XL"];
export const UKURAN_ANAK = ["XXS", "XS", "S", "M", "L", "XL", "2XL"];

/** K222 / T17 / T18 / T66: usulan `GET /fa-orders/usulan-dari-pd/{dr}` → keadaan awal wizard Buat FA. Baris pesanan
 *  per jenis × ukuran DARI DAFTAR NAMA customer (bukan angka PD lama); daftar nama ikut terisi. */
export function isiDariUsulan(usulan, kepalaLama) {
  const k = usulan?.kepala || {};
  const kepala = {
    ...(kepalaLama || {}),
    ...(k.package_category ? { package_category: k.package_category } : {}),
    ...(k.pola_baju ? { pola_baju: k.pola_baju } : {}),
    ...(k.collar_id ? { collar_id: k.collar_id } : {}),
    ...(k.warna_celana ? { warna_celana: k.warna_celana } : {}),
  };
  const items = (usulan?.items || []).map((i) => ({
    item_type: i.item_type || "", product_type: "ATASAN_ONLY", qty_atasan: i.qty_atasan,
    size_code: i.size_code || "", item_type_atasan: "", fabric_atasan: "", item_type_celana: "", fabric_celana: "",
    description: i.description || "", design_ref: "",
  }));
  const roster = (usulan?.roster || []).map((r) => ({
    row_no: r.row_no, nameset_punggung: r.nameset_punggung || "", nomor_punggung: r.nomor_punggung || "",
    ukuran_dewasa: r.ukuran_dewasa || "", ukuran_anak: r.ukuran_anak || "", ukuran_celana: r.ukuran_celana || "",
    gender: "", jenis_lengan: r.jenis_lengan || "PENDEK",
    baris_item: r.baris_item == null ? "" : String(r.baris_item),
  }));
  return { kepala, items, roster, namaTeam: k.nama_team || "" };
}

/** T17: apa yang staf UBAH dari pilihan customer — ditampilkan sebagai peringatan dan wajib beralasan saat simpan. */
export function bedaDariIsian(usulan, kepala, items, roster) {
  if (!usulan?.ada_isian) return [];
  const beda = [];
  const k = usulan.kepala || {};
  if (k.pola_baju && kepala?.pola_baju !== k.pola_baju) beda.push(`Pola baju: customer memilih ${k.pola_baju === "RAGLAN" ? "Raglan" : "Reguler"}`);
  if (k.collar_id && kepala?.collar_id !== k.collar_id) beda.push(`Kerah: customer memilih ${k.collar_nama || "kerah lain"}`);
  if (k.package_category && kepala?.package_category !== k.package_category) beda.push(`Kategori harga: customer memastikan ${k.package_category}`);
  if (k.warna_celana && kepala?.warna_celana !== k.warna_celana) beda.push(`Warna celana: customer memilih ${k.warna_celana === "HITAM" ? "Hitam" : "Putih"}`);
  const total = (items || []).reduce((s, i) => s + Number(i.qty_atasan || 0), 0);
  if (usulan.jumlah && total !== usulan.jumlah) beda.push(`Jumlah: daftar nama customer ${usulan.jumlah} orang, FA ${total} lembar`);
  if (usulan.jumlah && (roster || []).length !== usulan.jumlah) beda.push(`Daftar nama: customer ${usulan.jumlah} baris, di FA ${(roster || []).length} baris`);
  return beda;
}
